import { Box, Card, Stack, Typography } from '@dtx-company/design-system/src'
import { ForgotPasswordForm } from '@dtx-company/app/shared/code/src/components/organisms/forgot-password-form'
import { PageContainer } from '../components/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import useTranslation from 'next-translate/useTranslation'
import type { NextPage } from 'next'

const ForgotPassword: NextPage = () => {
  const { t } = useTranslation('auth')
  return (
    <PageContainer
      disableSideNav
      page={Routes.FORGOT_PASSWORD}
      backgroundColor={['unset', 'unset', 'secondary.backgroundDark']}
    >
      <main>
        <Stack gap={8} alignItems={'center'} sx={{ mt: 10, mb: 10 }}>
          <Typography variant={'headlineLarge'}>{t('ResetPassword.title')}</Typography>
          <Card
            sx={{
              display: { xs: 'none', md: 'block' },
              boxShadow: 3,
              width: '550px',
              margin: '0 auto',
              padding: '40px'
            }}
          >
            <ForgotPasswordForm returnLink={Routes.SIGN_IN} />
          </Card>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <ForgotPasswordForm returnLink={Routes.SIGN_IN} />
          </Box>
        </Stack>
      </main>
    </PageContainer>
  )
}

export default ForgotPassword
